import { computed } from 'vue';
import { FileHandler } from './file-handler';

export type UploadedFileResult = {
  file: File;
  upload: {
    key: string;
    originalName: string;
    url: string;
  };
};

export const useSingleFileUpload = () => {
  const fileHandler = new FileHandler();
  const uploadStatus = computed(() => fileHandler.uploadStatus.value);

  const uploadFile = async (file: File): Promise<UploadedFileResult> => {
    const upload = await fileHandler.uploadFile({ file });

    return {
      file,
      upload: {
        key: upload.key,
        originalName: upload.originalName,
        url: upload.url,
      },
    };
  };

  const resetUpload = () => {
    fileHandler.delete();
  };

  return {
    uploadStatus,
    uploadFile,
    resetUpload,
  };
};
